import { RiskbedomningData, Fraga, SvarData } from '@/types/riskbedomning';

/**
 * Filters questions that have been answered with "N/A"
 */
export const filterNAQuestions = (
  riskbedomningData: RiskbedomningData,
  allQuestions: Fraga[]
): Fraga[] => {
  return allQuestions.filter(fraga => {
    const svar = riskbedomningData.svar?.[fraga.id];
    return svar?.svar === 'na';
  });
};

/**
 * Groups N/A questions by category based on question text or category field
 */
export const groupNAQuestionsByCategory = (naQuestions: Fraga[]): Record<string, Fraga[]> => {
  const grouped: Record<string, Fraga[]> = {};
  
  naQuestions.forEach(fraga => {
    // Try to extract category from question structure or text
    let category = 'Övriga frågor';
    
    // Try to infer category from question text patterns
    const questionText = fraga.text.toLowerCase();
    
    if (questionText.includes('sprängning') || questionText.includes('sprängarbete')) {
      category = 'Sprängningsarbeten';
    } else if (questionText.includes('kran') || questionText.includes('lyft')) {
      category = 'Kranarbeten och lyft';
    } else if (questionText.includes('grävning') || questionText.includes('schakt')) {
      category = 'Grävnings- och schaktarbeten';
    } else if (questionText.includes('transport') || questionText.includes('fordon')) {
      category = 'Transport och fordonshantering';  
    } else if (questionText.includes('miljö') || questionText.includes('kemisk')) {
      category = 'Miljö och kemiska risker';
    } else if (questionText.includes('brand') || questionText.includes('explosion')) {
      category = 'Brand- och explosionsrisker';
    } else if (questionText.includes('fall') || questionText.includes('höjd')) {
      category = 'Fallrisker och arbete på höjd';
    } else if (questionText.includes('el') || questionText.includes('elektrisk')) {
      category = 'Elektriska risker';
    } else if (questionText.includes('buller') || questionText.includes('vibration')) {
      category = 'Buller och vibrationer';
    } else if (questionText.includes('ergonomi') || questionText.includes('tunga lyft')) {
      category = 'Ergonomi och arbetsmiljö';
    }
    
    if (!grouped[category]) {
      grouped[category] = [];
    }
    
    grouped[category].push(fraga);
  });
  
  return grouped;
};

/**
 * Creates formatted text for N/A summary section
 */
export const createNASummaryText = (groupedNAQuestions: Record<string, Fraga[]>): string => {
  const categories = Object.keys(groupedNAQuestions).sort();
  
  if (categories.length === 0) {
    return 'Inga frågor har bedömts som ej tillämpliga för detta projekt.';
  }
  
  let summaryText = 'Följande områden och frågor har bedömts som ej tillämpliga för detta projekt:\n\n';
  
  categories.forEach(category => {
    const questions = groupedNAQuestions[category];
    summaryText += `**${category}:**\n`;
    questions.forEach((fraga, index) => {
      summaryText += `${index + 1}. ${fraga.text}\n`;
    });
    summaryText += '\n';
  });
  
  return summaryText;
};